import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductPriceSavings extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSavings);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSavings);
  }

  /**
   * Updates the savings badge.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSavings = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const blockId = this.dataset.blockId;
    const newSavings = blockId
      ? event.detail.data.html.querySelector(`product-price-savings[data-block-id="${blockId}"]`)
      : event.detail.data.html.querySelector('product-price-savings');

    if (!newSavings) return;

    morph(this, newSavings, { childrenOnly: true });
  };
}

if (!customElements.get('product-price-savings')) {
  customElements.define('product-price-savings', ProductPriceSavings);
}
